import { createSelector } from 'reselect';
import { getPageFirstCardData, getPageFeatureFlags } from 'src/universal/redux/page';

export const getData = createSelector(
  [getPageFirstCardData, getPageFeatureFlags],
  ({ businessValueTiles, shortName }, featureFlags) => {
    if (!businessValueTiles) {
      return { shouldRender: false, shortName };
    }

    let shouldRender = true;

    if (shortName === 'gold' && !featureFlags.showKaratFeature) {
      shouldRender = false;
    }

    return { ...businessValueTiles, shouldRender, shortName };
  }
);
